<template>
  <div class="container">
    <div class="chart_title_cla">
      <div class="title-bg-cla"></div>
      <div class="title-Text-cla">{{ $t('dashboard.globalDeviceDis') }}</div>
      <div class="map-title-bg-cla"></div>
    </div>
    <div id="echartContainer"></div>
    <div class="visualMap-box-cla"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { getOption } from './chart.js'
import { devAreaInfo } from '@/services/dashboardApi.js'
let wordJson = require('./../../../../map/json/world.json')
echarts.registerMap('world', wordJson)
export default {
  data() {
    return {
      myChart: null,
      chartData: null,
      timeout: null,
      option: null,
      intervalMapChar: null
    }
  },
  mounted() {
    this.getdevAreaInfo()
    this.intervalMapChar = setInterval(() => {
      this.getdevAreaInfo()
    }, 10000)
    window.addEventListener('resize', this.resizeChart, true)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeChart, true)
    if (this.myChart) {
      this.myChart.clear()
      this.myChart.dispose()
      this.myChart = null
    }
    if (this.intervalMapChar) {
      clearInterval(this.intervalMapChar)
    }
  },
  methods: {
    resizeChart() {
      if (this.myChart) {
        this.debounce(this.myChart.resize, 200)
      }
    },
    debounce(func, wait) {
      let context = this
      if (this.timeout) {
        clearTimeout(this.timeout)
        this.timeout = null
      }
      this.timeout = setTimeout(() => {
        func.apply(context, arguments)
      }, wait)
    },
    rendChart(option) {
      if (!this.myChart) {
        this.myChart = echarts.init(document.getElementById('echartContainer'))
      }
      if (!option) {
        option = this.option
      }
      if (!option) {
        this.getdevAreaInfo()
      }
      this.myChart.setOption(option, true)
    },
    getOption() {
      this.option = getOption(this.chartData)
      this.rendChart(this.option)
    },
    getdevAreaInfo() {
      devAreaInfo()
        .then((data) => {
          if (data.code === '00000000') {
            this.chartData = data.payload.data
            this.getOption()
          }
        })
        .catch((e) => {
          console.error('请求设备分布接口异常')
        })
    }
  }
}
</script>

<style scoped lang="less">
@baseColor: #1384d5;
.container {
  width: 100%;
  height: 100%;
  position: relative;
  background-image: url('~~@/assets/new/dashboard/dashboardBg.png');
  background-size: 100% 100%;
  background-position-x: 140px;
  background-position-y: 30px;
  .map-title-bg-cla {
    background-image: url('~~@/assets/new/dashboard/secondBg.png');
    width: 203px;
    height: 18px;
    background-size: contain;
    position: absolute;
    right: 0px;
    top: 50%;
    margin-top: -9px;
  }
  #echartContainer {
    width: 100%;
    height: 100%;
    z-index: 1;
  }
  .visualMap-box-cla {
    position: absolute;
    right: 0px;
    bottom: 9em;
    font-size: 2px;
    border: 1px dashed #31b1b5;
    width: 35em;
    height: 94em;
    z-index: 0;
    background-color:rgba(49,180,183,0.10);
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/tenantManager/dashboard/mapchar/worldMap.vue